import { useAuth } from "../auth/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const {
    isAuthenticated,
    isConfirmed,
    hasProfile,
    emailMissing,
    isAdmin,
    loading,
  } = useAuth();
  const location = useLocation();

  // Show loading while authentication is being checked
  if (loading) {
    return <div>Loading...</div>;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but not confirmed, redirect to confirmation page
  if (isAuthenticated && !isConfirmed) {
    return <Navigate to="/confirm" replace />;
  }

  // Regular users: if authenticated and confirmed but no profile, redirect to profile page
  // Exception: if already on profile page, allow access
  if (
    !isAdmin &&
    isAuthenticated &&
    isConfirmed &&
    !hasProfile &&
    location.pathname !== "/profile"
  ) {
    return <Navigate to="/profile" replace />;
  }

  // Regular users: profile exists, but has no email on record (e.g. it
  // predates an email being added in Cognito). Saving the profile re-syncs
  // the email from the JWT, so send them there until that's happened —
  // same pattern as the no-profile case above. This applies regardless of
  // notification preference — a missing email is an incomplete profile
  // either way.
  if (
    !isAdmin &&
    isAuthenticated &&
    isConfirmed &&
    hasProfile &&
    emailMissing &&
    location.pathname !== "/profile"
  ) {
    return <Navigate to="/profile" replace />;
  }

  // Redirect admin away from non-admin pages
  if (isAdmin && location.pathname === "/dashboard") {
    return <Navigate to="/admin/results" replace />;
  }

  // All checks passed, render the protected component
  return children;
};

export default ProtectedRoute;
